module.exports = __webpack_public_path__ + "static/media/grin-stars.e0381021.svg";